(function ($) {
  if (!$('body').hasClass('page-template-skoda-la-vuelta-2023')) {
    return;
  }

  var $prizeSlider = $('.prize-slider'),
    prizesData = $prizeSlider.data('prizes'),
    activeSlide = 1,
    maxSlides = Object.keys(prizesData).length,
    animationTime = 250,
    animating = false,
    $dots = $('.prize-slider-dot'),
    $title = $('.prize-slider-title'),
    $description = $('.prize-slider-text'),
    $count = $('.prize-slider-count-number'),
    $prizeImage = $('.prize-slider-image img'),
    hideLeftArrow = true,
    hideRightArrow = activeSlide !== maxSlides;

  function updateDots() {
    $dots.removeClass('active');
    $('.prize-slider-dot[data-id="' + activeSlide + '"]').addClass('active');
  }

  function updateSlider($clickedArrowElement) {
    animateArrows($clickedArrowElement);

    // Animate title
    $title.animate(
      {
        opacity: 0,
      },
      animationTime,
      'swing',
      function () {
        $title.html(prizesData[activeSlide].title);

        setTimeout(function () {
          $title.animate(
            {
              opacity: 1,
            },
            animationTime,
            'swing'
          );
        }, animationTime);
      }
    );

    // Animate count number
    $count.animate(
      {
        opacity: 0,
      },
      animationTime,
      'swing',
      function () {
        $count.html(prizesData[activeSlide].count);

        setTimeout(function () {
          $count.animate(
            {
              opacity: 1,
            },
            animationTime,
            'swing'
          );
        }, animationTime);
      }
    );

    // Animate prize image
    $prizeImage.animate(
      {
        opacity: 0,
        left: 50,
      },
      animationTime,
      'swing',
      function () {
        setTimeout(function () {
          $prizeImage
            .attr('src', prizesData[activeSlide].img)
            .css('left', -50)
            .animate(
              {
                opacity: 1,
                left: 0,
              },
              animationTime,
              'swing'
            );
        }, animationTime);
      }
    );

    // Animate description with a 2x delay and since it's the slowest, reset animating to false.
    $description.animate(
      {
        opacity: 0,
      },
      animationTime,
      'swing',
      function () {
        $description.html(prizesData[activeSlide].desc);

        setTimeout(function () {
          $description.animate(
            {
              opacity: 1,
            },
            animationTime,
            'swing',
            function () {
              animating = false;
            }
          );
        }, animationTime * 2);
      }
    );

    updateDots();
  }

  function animateArrows($clickedArrowElement) {
    hideLeftArrow = activeSlide === 1;
    hideRightArrow = activeSlide === maxSlides;

    if (hideLeftArrow) {
      $('.prize-slider-arrow.left').addClass('hide');
    } else {
      $('.prize-slider-arrow.left').removeClass('hide');
    }
    if (hideRightArrow) {
      $('.prize-slider-arrow.right').addClass('hide');
    } else {
      $('.prize-slider-arrow.right').removeClass('hide');
    }

    if ($clickedArrowElement !== false) {
      $clickedArrowElement.animate(
        {
          opacity: 0.5,
        },
        animationTime,
        'swing',
        function () {
          $clickedArrowElement.animate({ opacity: 1 }, animationTime, 'swing');
        }
      );
    }
  }

  $('.prize-slider-arrow').on('click touchstart', function (e) {
    e.preventDefault();

    if (animating) {
      return;
    }

    animating = true;

    var $this = $(this);

    // Set correct slide
    if ($this.hasClass('left')) {
      activeSlide--;
      if (activeSlide < 1) {
        activeSlide = maxSlides;
      }
    } else {
      activeSlide++;
      if (activeSlide > maxSlides) {
        activeSlide = 1;
      }
    }

    updateSlider($this);
  });

  $dots.on('click touchstart', function (e) {
    var $this = $(this);
    if (animating || $this.hasClass('active')) {
      return;
    }

    animating = true;

    activeSlide = $(this).data('id');

    updateSlider(false);
  });

  animateArrows(false);
})(jQuery);
